const menuItemFormParamFreq = {
  day: 'dias',
  month: 'meses'
};

export default menuItemFormParamFreq;
